<template>
  <div>
    <b-col
      cols="12"
      class="h5 text-azul-medio font-weight-normal px-0 text-center text-lg-left mt-5 gilmer d-print-none"
    >
      PROGRAMAS, EXTRACURRICULARES E INFRAESTRUCTURA
    </b-col>
    <div
      class="accordion mt-3 mb-5 filtros d-print-none"
      id="programas"
      role="tablist"
    >
      <!-- Actividades extraprogramáticas -->
      <b-card
        v-show="actividadesExtra.length > 0"
        no-body
        class="border-bottom"
      >
        <b-card-header
          class="p-0 bg-morado-claro"
          id="actividades-header"
          role="tab"
        >
          <b-button
            v-b-toggle.actividades-extraprogramaticas
            variant="outline"
            class="btn-wrap w-100 text-left pb-1 pt-2"
            id="collapse-actividades"
            data-testid="collapse-actividades"
            @click="
              $gtag.event('ver-actividad-extraprogramatica', {
                event_category: 'programas',
                event_label: 'ver-actividad-extraprogramatica',
                value: ''
              })
            "
          >
            <span class="row cx d-flex">
              <FontAwesomeIcon
                icon="drum"
                class="h5 text-center mr-1 fa-sm ml-2 mr-2"
              />
              <strong class="col-9 pl-2 border-left text-morado-claro"
                >Actividades extraprogramáticas</strong
              >
              <FontAwesomeIcon
                icon="angle-down"
                class="col-1 flechas float-right h5 px-0 mr-1"
              />
            </span>
          </b-button>
        </b-card-header>

        <b-collapse
          id="actividades-extraprogramaticas"
          accordion="acordion-programas"
          role="tabpanel"
        >
          <b-card-body class="py-2 px-3 text-morado-claro">
            <ul>
              <li
                v-for="(dato, index) in actividadesExtra"
                :key="'actividad-extra-' + index"
              >
                {{ dato.nombre }}
              </li>
            </ul>
          </b-card-body>
        </b-collapse>
      </b-card>
      <!-- Actividades extraprogramáticas fin -->

      <!-- Apoyo académico -->
      <b-card
        v-show="apoyoAcademico.length > 0"
        no-body
        class="mt-2 border-bottom"
      >
        <b-card-header
          class="card-header p-0 bg-morado-claro "
          id="apoyo-header"
          role="tab"
        >
          <b-button
            v-b-toggle.apoyo
            variant="outline"
            class="btn-wrap w-100 text-left pb-1 pt-2"
            id="collapse-apoyo"
            data-testid="collapse-apoyo"
            @click="
              $gtag.event('ver-apoyo-academico', {
                event_category: 'programas',
                event_label: 'ver-apoyo-academico',
                value: ''
              })
            "
          >
            <span class="row cx d-flex">
              <FontAwesomeIcon
                icon="book-reader"
                class="h5 text-center mr-1 fa-sm ml-2 mr-2"
              />
              <strong class="col-9 pl-2 border-left text-morado-claro "
                >Apoyo académico</strong
              >
              <FontAwesomeIcon
                icon="angle-down"
                class="col-1 flechas float-right h5 px-0 mr-1"
              />
            </span>
          </b-button>
        </b-card-header>

        <b-collapse id="apoyo" accordion="acordion-programas" role="tabpanel">
          <div class="card-body py-2 px-3 text-morado-claro">
            <ul>
              <li
                v-for="(dato, index) in apoyoAcademico"
                :key="'apoyo-academico-' + index"
              >
                {{ dato.nombre }}
              </li>
            </ul>
          </div>
        </b-collapse>
      </b-card>
      <!-- Apoyo académico fin -->

      <!-- Deportes -->
      <b-card v-show="deportes.length > 0" no-body class="mt-2 border-bottom">
        <b-card-header
          class="p-0 bg-morado-claro"
          id="deportes-header"
          role="tab"
        >
          <b-button
            v-b-toggle.deportes
            variant="outline"
            class="btn-wrap w-100 text-left pb-1 pt-2"
            id="collapse-deportes"
            data-testid="collapse-deportes"
            @click="
              $gtag.event('ver-deportes', {
                event_category: 'programas',
                event_label: 'ver-deportes',
                value: ''
              })
            "
          >
            <span class="row cx d-flex">
              <FontAwesomeIcon
                icon="futbol"
                class="h5 text-center mr-1 fa-sm ml-2 mr-2"
              />
              <strong class="col-9 pl-2 border-left text-morado-claro"
                >Deportes</strong
              >
              <FontAwesomeIcon
                icon="angle-down"
                class="col-1 flechas float-right h5 px-0 mr-1"
              />
            </span>
          </b-button>
        </b-card-header>

        <b-collapse
          id="deportes"
          accordion="acordion-programas"
          role="tabpanel"
        >
          <b-card-body class="py-2 px-3 text-morado-claro">
            <ul>
              <li v-for="(dato, index) in deportes" :key="'deportes-' + index">
                {{ dato.nombre }}
              </li>
            </ul>
          </b-card-body>
        </b-collapse>
      </b-card>
      <!-- Deportes fin -->

      <!-- Idioma -->
      <b-card v-show="idiomas.length > 0" no-body class="mt-2 border-bottom">
        <b-card-header
          class="p-0 bg-morado-claro"
          id="idiomas-header"
          role="tab"
        >
          <b-button
            v-b-toggle.idiomas
            variant="outline"
            class="btn-wrap w-100 text-left pb-1 pt-2"
            id="collapse-idiomas"
            data-testid="collapse-idiomas"
            @click="
              $gtag.event('ver-idioma', {
                event_category: 'programas',
                event_label: 'ver-idioma',
                value: ''
              })
            "
          >
            <span class="row cx d-flex">
              <FontAwesomeIcon
                icon="headphones-alt"
                class="h5 text-center mr-1 fa-sm ml-2 mr-2"
              />
              <strong class="col-9 pl-2 border-left text-morado-claro"
                >Idioma</strong
              >
              <FontAwesomeIcon
                icon="angle-down"
                class="col-1 flechas float-right h5 px-0 mr-1"
              />
            </span>
          </b-button>
        </b-card-header>

        <b-collapse id="idiomas" accordion="acordion-programas" role="tabpanel">
          <b-card-body class="py-2 px-3 text-morado-claro">
            <ul>
              <li v-for="(dato, index) in idiomas" :key="'idiomas-' + index">
                {{ dato.nombre }}
              </li>
            </ul>
          </b-card-body>
        </b-collapse>
      </b-card>
      <!-- Idioma fin -->

      <!-- Infraestructura -->
      <b-card
        v-show="infraestructura.length > 0"
        no-body
        class="mt-2 border-bottom"
      >
        <b-card-header
          class="p-0 bg-morado-claro"
          id="infraestructura-header"
          role="tab"
        >
          <b-button
            v-b-toggle.infraestructura
            variant="outline"
            class="btn-wrap w-100 text-left pb-1 pt-2"
            id="collapse-infraestructura"
            data-testid="collapse-infraestructura"
            @click="
              $gtag.event('ver-infraestructura', {
                event_category: 'programas',
                event_label: 'ver-infraestructura',
                value: ''
              })
            "
          >
            <span class="row cx d-flex">
              <FontAwesomeIcon
                icon="university"
                class="h5 text-center mr-1 fa-sm ml-2 mr-2"
              />
              <strong class="col-9 pl-2 border-left text-morado-claro"
                >Infraestructura</strong
              >
              <FontAwesomeIcon
                icon="angle-down"
                class="col-1 flechas float-right h5 px-0 mr-1"
              />
            </span>
          </b-button>
        </b-card-header>

        <b-collapse
          id="infraestructura"
          accordion="acordion-programas"
          role="tabpanel"
        >
          <b-card-body class="py-2 px-3 text-morado-claro">
            <ul>
              <li
                v-for="(dato, index) in infraestructura"
                :key="'infraestructura-' + index"
              >
                {{ dato.nombre }}
              </li>
            </ul>
          </b-card-body>
        </b-collapse>
      </b-card>
      <!-- Infraestructura fin -->

      <!-- Programas -->
      <b-card v-show="programas.length > 0" no-body class="mt-2 border-bottom">
        <b-card-header
          class="p-0 bg-morado-claro"
          id="programas-header"
          role="tab"
        >
          <b-button
            v-b-toggle.programas
            variant="outline"
            class="btn-wrap w-100 text-left pb-1 pt-2"
            id="collapse-programas"
            data-testid="collapse-programas"
            @click="
              $gtag.event('ver-programas', {
                event_category: 'programas',
                event_label: 'ver-programas',
                value: ''
              })
            "
          >
            <span class="row cx d-flex">
              <FontAwesomeIcon
                icon="hand-holding-heart"
                class="h5 text-center mr-1 fa-sm ml-2 mr-2"
              />
              <strong class="col-9 pl-2 border-left text-morado-claro"
                >Programas</strong
              >
              <FontAwesomeIcon
                icon="angle-down"
                class="col-1 flechas float-right h5 px-0 mr-1"
              />
            </span>
          </b-button>
        </b-card-header>

        <b-collapse
          id="programas"
          accordion="acordion-programas"
          role="tabpanel"
        >
          <b-card-body class="py-2 px-3 text-morado-claro">
            <ul>
              <li v-for="(dato, index) in programas" :key="'progrmas-' + index">
                {{ dato.nombre }}
              </li>
            </ul>
          </b-card-body>
        </b-collapse>
      </b-card>
      <!-- Programas fin -->
    </div>
  </div>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faAngleDown,
  faDrum,
  faBookReader,
  faFutbol,
  faHeadphonesAlt,
  faUniversity,
  faHandHoldingHeart
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(
  faAngleDown,
  faDrum,
  faBookReader,
  faFutbol,
  faHeadphonesAlt,
  faUniversity,
  faHandHoldingHeart
);
export default {
  //components
  components: {
    FontAwesomeIcon
  },
  props: {
    actividades: {
      type: Array,
      required: true
    }
  },
  computed: {
    //calculo de actividades extraprogramaticas
    actividadesExtra() {
      return this.actividades.filter(e => {
        return e.tipo === "ACTIVIDADES EXTRAPROGRAMÁTICAS";
      });
    },
    //calculo de apoyo academico
    apoyoAcademico() {
      return this.actividades.filter(e => {
        return e.tipo === "APOYO ACADÉMICO";
      });
    },
    //calculo de deportes
    deportes() {
      return this.actividades.filter(e => {
        return e.tipo === "DEPORTES";
      });
    },
    //calculo de idiomas
    idiomas() {
      return this.actividades.filter(e => {
        return e.tipo === "IDIOMA";
      });
    },
    //calculo de infraestructura
    infraestructura() {
      return this.actividades.filter(e => {
        return e.tipo === "INFRAESTRUCTURA";
      });
    },
    //calculo de programas
    programas() {
      return this.actividades.filter(e => {
        return e.tipo === "PROGRAMAS";
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ficha/izquierda/ProgramasYExtras.vue